<div oSticky [stickyOffset]="60" [applySticky]="true" class="header-sticky">
  <o-search-bar (textEnter)="valueChange($event)" [placeHolder]="'search.label' | translate"> </o-search-bar>

  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    @for (tab of tabs; track tab.id) {
      @if (tab.isVisible) {
        <a
          mat-tab-link
          [routerLink]="tab.id"
          [queryParams]="tab.queryParams"
          [active]="(currentTab | async) === tab.id"
          [disabled]="tab.disabledOnDegraded && (isDegradedState | async)">
          {{ "home.tab." + tab.id | translate }}
        </a>
      }
    }
  </nav>
</div>

<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
